import { apiRequest } from "./api";
import type { Role, MembershipInfo } from "../types/index";
import type { PageKey } from "../types/pages";

export interface CreateRolePayload {
  name: string;
  description?: string;
  pages: PageKey[];
}

export interface UpdateRolePayload {
  name?: string;
  description?: string;
  pages?: PageKey[];
}

export interface PermissionsResponse {
  roleId: string | null;
  permittedPages: PageKey[] | "*";
  pagesByBusiness?: Record<string, PageKey[]>;
  memberships?: MembershipInfo[];
}

export const roleApi = {
  listAssignablePages: () =>
    apiRequest<{ pages: readonly PageKey[] }>("/admin/roles/pages"),

  list: () =>
    apiRequest<{ items: Role[] }>("/admin/roles"),

  get: (roleId: string) =>
    apiRequest<Role>(`/admin/roles/${roleId}`),

  create: (payload: CreateRolePayload) =>
    apiRequest<Role>("/admin/roles", { method: "POST", body: payload }),

  update: (roleId: string, payload: UpdateRolePayload) =>
    apiRequest<Role>(`/admin/roles/${roleId}`, { method: "PUT", body: payload }),

  delete: (roleId: string) =>
    apiRequest<void>(`/admin/roles/${roleId}`, { method: "DELETE" }),

  getMyPermissions: () =>
    apiRequest<PermissionsResponse>("/me/permissions"),
};

export const bizRoleApi = {
  listAssignablePages: (businessId: string) =>
    apiRequest<{ pages: readonly PageKey[] }>(`/biz/${businessId}/roles/pages`),

  list: (businessId: string) =>
    apiRequest<{ items: Role[] }>(`/biz/${businessId}/roles`),

  get: (businessId: string, roleId: string) =>
    apiRequest<Role>(`/biz/${businessId}/roles/${roleId}`),

  create: (businessId: string, payload: CreateRolePayload) =>
    apiRequest<Role>(`/biz/${businessId}/roles`, { method: "POST", body: payload }),

  update: (businessId: string, roleId: string, payload: UpdateRolePayload) =>
    apiRequest<Role>(`/biz/${businessId}/roles/${roleId}`, { method: "PUT", body: payload }),

  delete: (businessId: string, roleId: string) =>
    apiRequest<void>(`/biz/${businessId}/roles/${roleId}`, { method: "DELETE" }),
};
